import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { X, Package, User, Users } from "lucide-react";

export function ChatContext({ 
  selectedProduct, 
  selectedCustomer, 
  selectedRepresentative,
  onClearContext,
  onClearProduct,
  onClearCustomer,
  onClearRepresentative
}) {
  const hasContext = selectedProduct || selectedCustomer || selectedRepresentative;

  if (!hasContext) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium text-blue-900">Contexto de la Sesión</h4>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearContext}
          className="h-6 w-6 p-0 text-blue-600 hover:text-blue-800"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
      
      <div className="space-y-2">
        {selectedProduct && (
          <div className="flex items-center justify-between bg-white rounded p-2 border">
            <div className="flex items-center gap-2">
              <Package className="h-4 w-4 text-blue-600" />
              <div>
                <p className="text-sm font-medium">{selectedProduct.code}</p>
                <p className="text-xs text-gray-600">{selectedProduct.description}</p>
              </div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearProduct}
              className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        )}

        {selectedCustomer && (
          <div className="flex items-center justify-between bg-white rounded p-2 border">
            <div className="flex items-center gap-2">
              <User className="h-4 w-4 text-green-600" />
              <div>
                <p className="text-sm font-medium">{selectedCustomer.name}</p>
                <p className="text-xs text-gray-600">{selectedCustomer.code}</p>
              </div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearCustomer}
              className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        )}

        {selectedRepresentative && (
          <div className="flex items-center justify-between bg-white rounded p-2 border">
            <div className="flex items-center gap-2">
              <Users className="h-4 w-4 text-purple-600" />
              <div>
                <p className="text-sm font-medium">{selectedRepresentative.name}</p>
                <p className="text-xs text-gray-600">{selectedRepresentative.cod_rep}</p>
              </div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearRepresentative}
              className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
            >
              <X className="h-3 w-3" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
} 